import { Box, Chip } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers';

const CurrentUserNavBarItem = () => {
    const clinician = useSelector((state: RootState) => state.AuthReducer.user);
    const acl = useSelector((state: RootState) => state.AuthReducer.acl);
    const isOrgAdmin = acl?.role === 'org-admin';

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {isOrgAdmin && (
                <Chip
                    icon={<AdminPanelSettingsIcon style={{ color: '#1a1a1a' }} />}
                    label="Org Admin"
                    size="small"
                    style={{ backgroundColor: '#f59e0b', color: '#1a1a1a', fontWeight: 600 }}
                />
            )}
            <Chip
                label={clinician ? clinician.email : ''}
                variant="outlined"
                color="secondary"
                style={{ color: '#fff' }}
            />
        </Box>
    );
};

export default CurrentUserNavBarItem;
